// Cores das bandeiras estaduais — hex exclusivamente da lista fornecida
// pelo usuário (uma cor por UF, na ordem em que aparece no campo da
// bandeira). Como várias UFs compartilham a mesma cor/hex entre si (ex.:
// vários estados têm branco, ou o mesmo tom de verde #00923F), cada UF usa
// a cor disponível mais alta na sua própria lista que ainda não tenha sido
// usada por outra UF — nenhum hex se repete entre estados. Quando o
// comentário não é a 1ª cor da lista original daquela UF, foi porque a
// preferida colidia com outra UF já resolvida.
export const STATE_FLAG_COLORS = {
    AC: '#FFD700', // amarelo (1ª opção)
    AL: '#0077B9', // azul (vermelho/branco colidiam com RS/MG)
    AP: '#009A44', // verde (1ª opção)
    AM: '#D20000', // vermelho (branco colidia com MG)
    BA: '#C8110F', // vermelho (branco colidia com MG)
    CE: '#00923F', // verde (1ª opção)
    DF: '#FFF500', // amarelo (branco/verde colidiam com MG/CE)
    ES: '#87CEEB', // azul claro (1ª opção)
    GO: '#008751', // verde (1ª opção)
    MA: '#E31B23', // vermelho (1ª opção)
    MT: '#002060', // azul (1ª opção)
    MS: '#6699FE', // azul (1ª opção)
    MG: '#FFFFFF', // branco (1ª opção)
    PA: '#CE1126', // vermelho (1ª opção)
    PB: '#D2122E', // vermelho (1ª opção)
    PR: '#009B3A', // verde (1ª opção)
    PE: '#3155A4', // azul (1ª opção)
    PI: '#006A4E', // verde (1ª opção)
    RJ: '#00AFEF', // azul (1ª opção)
    RN: '#FEDF00', // amarelo (verde colidia com PR)
    RS: '#DA251D', // vermelho (verde/amarelo colidiam com CE/DF)
    RO: '#00994C', // verde (1ª opção)
    RR: '#008200', // verde (1ª opção)
    SC: '#007A33', // verde (vermelho colidia com PA)
    SP: '#000000', // preto (1ª opção)
    SE: '#F8C300', // amarelo (verde colidia com CE)
    TO: '#1946B4', // azul (1ª opção)
};

const NEUTRAL_COLOR = '#9E9E9E';

export const stateFlagColor = (uf) => STATE_FLAG_COLORS[uf] || NEUTRAL_COLOR;
